export enum CallTypeEnum {
    MFC = 'MFC',
    MOC = 'MOC',
    MOCNMO = 'MOCNMO',
    MOCI = 'MOCI',
    MOPC = 'MOPC',
    MTC = 'MTC',
    MTPC = 'MTPC',
    RFC = 'RFC',
    ROC = 'ROC',
    RTC = 'RTC'
}